import { useSyncExternalStore } from 'react'

/** One shared clock for relative times and overdue state; ticks every 60s (DESIGN.md §5). */
const TICK_MS = 60_000
let now = Date.now()
const listeners = new Set<() => void>()
let timer: number | undefined

function subscribe(onChange: () => void) {
  listeners.add(onChange)
  if (timer === undefined) {
    now = Date.now()
    // The snapshot may be stale from an earlier session of the clock: re-read it.
    queueMicrotask(onChange)
    timer = window.setInterval(() => {
      now = Date.now()
      for (const l of listeners) l()
    }, TICK_MS)
  }
  return () => {
    listeners.delete(onChange)
    if (listeners.size === 0) {
      window.clearInterval(timer)
      timer = undefined
    }
  }
}

/** Current time in ms, re-rendering subscribers once a minute. */
export function useNow(): number {
  return useSyncExternalStore(
    subscribe,
    () => now,
    () => now,
  )
}
